import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
	name: 'utcOffset'
})
export class UTCOffsetPipe implements PipeTransform {
	// value: unix timeStamp
	// offsetMinutes: offset in minutes
	// localOffset: computers local offset
	transform(value: any, localOffset: number, offsetMinutes: number) {
		if (offsetMinutes && localOffset != null) {
			const finalOffset = (localOffset + offsetMinutes) * 60000;
			return value + finalOffset;
		} else if (value) {
			return value;
		}
	}
}
